"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onExportFailed = exports.getYesterday = exports.getExist = exports.getCurrentDay = exports.getCurrentWeekDays = exports.getErrorExcelName = exports.getExcelName = exports.getRange = exports.flatten = exports.generateArray = exports.filterInvalid = exports.sumArr = exports.errorCaptured = exports.outputExcel = exports.readExcel = exports.onRequest = exports.getPagination = exports.onPagination = exports.goQuery = exports.getQuery = exports.goQueryAdd = exports.onErrorNotice = exports.getErrorMsg = void 0;
var antd_1 = require("antd");
var qs_1 = require("qs");
// @ts-ignore
var umi_1 = require("umi");
var bv_data_1 = require("bv-data");
var xlsx_1 = require("xlsx");
var bv_validator_1 = require("bv-validator");
var dayjs_1 = __importDefault(require("dayjs"));
var lodash_1 = require("lodash");
var getErrorMsg = function (msg, defaultError) {
    if (defaultError === void 0) { defaultError = 'Unknown Error'; }
    if (!msg) {
        return defaultError;
    }
    if (bv_validator_1.isElement(msg)) {
        return msg;
    }
    return msg.toString();
};
exports.getErrorMsg = getErrorMsg;
var onErrorNotice = function (msg, description, duration, defaultError) {
    var localMsg = getErrorMsg(msg, defaultError);
    antd_1.notification.error({
        message: localMsg,
        description: description ? getErrorMsg(description) : undefined,
        duration: duration,
    });
};
exports.onErrorNotice = onErrorNotice;
// 查询参数跳转
var goQuery = function (obj, arrayFormat) {
    if (arrayFormat === void 0) { arrayFormat = 'comma'; }
    umi_1.history.replace(qs_1.stringify(obj, { addQueryPrefix: true, arrayFormat: arrayFormat }) ||
        umi_1.history.location.pathname);
};
exports.goQuery = goQuery;
// 添加后获取 URL 查询参数
var getQuery = function (values) {
    if (values === void 0) { values = {}; }
    return (__assign(__assign({}, qs_1.parse(umi_1.history.location.query, {
        ignoreQueryPrefix: true,
        comma: true,
    })), values));
};
exports.getQuery = getQuery;
var goQueryAdd = function (values) {
    goQuery(getQuery(values));
};
exports.goQueryAdd = goQueryAdd;
var readExcel = function (f) { return (new Promise(function (resolve, reject) {
    var filenameReg = /\.((xls)x?|csv)/;
    var suffix = f.name.substring(f.name.lastIndexOf('.'));
    if (filenameReg.test(suffix)) {
        resolve();
    }
    else {
        antd_1.notification.error({ message: '请选择 xls(x) 和 csv 格式的文件' });
        reject();
    }
})); };
exports.readExcel = readExcel;
var outputExcel = function (data, name, options) {
    if (name === void 0) { name = 'output'; }
    var ws = xlsx_1.utils.json_to_sheet(data, __assign({ header: undefined, skipHeader: true }, options));
    var wb = xlsx_1.utils.book_new();
    // ws['!cols'] = [{ wpx: 160 }]
    xlsx_1.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx_1.writeFile(wb, name + ".xlsx");
};
exports.outputExcel = outputExcel;
var onRequest = function (api, success, failed) {
    if (api) {
        api.then(function (res) {
            var _a = __read(res, 2), response = _a[0], error = _a[1];
            if (error) {
                if (failed) {
                    if (typeof failed === "string") {
                        onErrorNotice(failed, error);
                    }
                    else {
                        failed(error);
                    }
                }
            }
            else {
                success === null || success === void 0 ? void 0 : success(response);
            }
        }).catch(function (error) {
            // eslint-disable-next-line no-console
            console.error(error.toString());
        });
    }
};
exports.onRequest = onRequest;
var getPagination = function (page) {
    var _a = page !== null && page !== void 0 ? page : {}, _b = _a.pageSize, pageSize = _b === void 0 ? 10 : _b, _c = _a.currentPage, current = _c === void 0 ? 1 : _c, _d = _a.total, total = _d === void 0 ? 0 : _d;
    return __assign(__assign({}, bv_data_1.defaultPagination), { position: ['bottomRight'], pageSize: Number(pageSize), current: Number(current), total: total, size: "small" });
};
exports.getPagination = getPagination;
var onPagination = function (pageInfo, callback, _defaultPageSize) {
    if (_defaultPageSize === void 0) { _defaultPageSize = bv_data_1.defaultPageSize; }
    var current = pageInfo.current, pageSize = pageInfo.pageSize;
    var _a = getQuery().pageSize, prePageSize = _a === void 0 ? _defaultPageSize : _a;
    var params = {
        // eslint-disable-next-line eqeqeq
        currentPage: (pageSize != prePageSize || current === 1) ? undefined : current,
        pageSize: pageSize === _defaultPageSize ? undefined : pageSize,
    };
    goQueryAdd(params);
    callback === null || callback === void 0 ? void 0 : callback(getQuery(params));
};
exports.onPagination = onPagination;
var errorCaptured = function (asyncFunc) { return __awaiter(void 0, void 0, void 0, function () {
    var res, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, asyncFunc()];
            case 1:
                res = _a.sent();
                return [2 /*return*/, [res, null]];
            case 2:
                e_1 = _a.sent();
                return [2 /*return*/, [null, e_1]];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.errorCaptured = errorCaptured;
var sumArr = function (arr) { return (bv_validator_1.isValue(arr) ? arr.reduce(function (n, m) { return n + m; }) : 0); };
exports.sumArr = sumArr;
var filterInvalid = function (obj) { return (lodash_1.pickBy(obj, function (v) { return (bv_validator_1.isValue(v)); })); };
exports.filterInvalid = filterInvalid;
var getExist = function (arr) { return arr.filter(function (item) { return bv_validator_1.isValue(item); }); };
exports.getExist = getExist;
var generateArray = function (len) { return __spreadArray([], __read(new Array(len).keys())); };
exports.generateArray = generateArray;
// 获取指定开始结束的数组
var getRange = function (start, end) {
    return Array(end - start + 1).fill(0).map(function (v, i) { return i + start; });
};
exports.getRange = getRange;
var flatten = function (arr) {
    return [].concat.apply([], __spreadArray([], __read(arr.map(function (x) { return bv_validator_1.isArray(x) ? flatten(x) : x; })))).filter(function (i) { return bv_validator_1.isValue(i); });
};
exports.flatten = flatten;
var getExcelName = function (name, length) {
    if (length === void 0) { length = 0; }
    return (name + "\u3010" + length + "\u3011 " + dayjs_1.default().format("YYYYMMDD HH:mm:ss"));
};
exports.getExcelName = getExcelName;
var getErrorExcelName = function (name, length, suffix) {
    if (length === void 0) { length = 0; }
    if (suffix === void 0) { suffix = '错误数据列表'; }
    return (getExcelName("" + name + suffix, length));
};
exports.getErrorExcelName = getErrorExcelName;
var onExportFailed = function (options, list, name, title, filed) {
    if (name === void 0) { name = '失败数据列表'; }
    if (title === void 0) { title = '失败原因'; }
    if (filed === void 0) { filed = 'errorInfo'; }
    outputExcel(__spreadArray([
        __spreadArray(__spreadArray([], __read((options.map(function (item) { return item.title; })))), [title])
    ], __read(list.map(function (item) { return options.map(function (_a) {
        var key = _a.key;
        return item === null || item === void 0 ? void 0 : item[key];
    }).concat(item === null || item === void 0 ? void 0 : item[filed]); }))), getExcelName(name, list.length));
};
exports.onExportFailed = onExportFailed;
var getCurrentWeekDays = function (format) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    return [
        dayjs_1.default().subtract(7, 'd').format(format),
        dayjs_1.default().format(format),
    ];
};
exports.getCurrentWeekDays = getCurrentWeekDays;
var getCurrentDay = function (format) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    return dayjs_1.default().format(format);
};
exports.getCurrentDay = getCurrentDay;
var getYesterday = function (format) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    return dayjs_1.default().subtract(1, 'd').format(format);
};
exports.getYesterday = getYesterday;
